import React from 'react';
import { browserHistory } from 'react-router';

const FormHeader = ({ headerTitle }) => (
  <div className="row row-head">
    <a onClick={() => browserHistory.goBack()} className="pull-left">
      <div className="icon-white_arrow_back"></div>
    </a>
    <div className="col-xs-12 col-md-8 col-md-offset-2">
      <h5>{headerTitle}</h5>Complete request
    </div>
  </div>
);

export default FormHeader;



// WEBPACK FOOTER //
// ./src/components/RequestForm/FormHeader.js